import { useStats } from '@/hooks/useStats';
import { formatNumber } from '@/lib/utils';
import { DEFAULT_AVATAR } from '@/lib/utils';

export function TopAuthors() {
  const { stats } = useStats();

  if (!stats?.topAuthors || stats.topAuthors.length === 0) {
    return null;
  }

  return (
    <div className="filter-group mb-4">
      <label className="block text-text-secondary text-xs font-semibold mb-2">热门作者</label>
      <div className="top-authors-list flex flex-col gap-2">
        {stats.topAuthors.slice(0, 10).map((author) => (
          <div
            key={author.screen_name}
            className="top-author-item flex items-center gap-2.5 px-2 py-2 bg-bg-tertiary rounded-lg cursor-pointer transition-colors hover:bg-border"
            onClick={() => {
              // Trigger author filter click
              const event = new CustomEvent('topAuthorClick', { detail: author.screen_name });
              window.dispatchEvent(event);
            }}
          >
            <img
              src={author.user_avatar_url || DEFAULT_AVATAR}
              alt=""
              className="top-author-avatar w-8 h-8 rounded-full object-cover"
              onError={(e) => {
                e.currentTarget.src = DEFAULT_AVATAR;
              }}
            />
            <div className="top-author-info flex-1 min-w-0">
              <div className="top-author-name text-sm font-semibold truncate">{author.user_name}</div>
              <div className="top-author-count text-text-muted text-xs">{formatNumber(author.tweet_count)} 条推文</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
